function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, n) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = n() : "function" == typeof define && define.amd ? define(n) : ((e = e || self).__vee_validate_locale__en = e.__vee_validate_locale__en || {}, e.__vee_validate_locale__en.js = n());
}(this, function () {
  "use strict";

  var e,
      n = {
    name: "en",
    messages: {
      _default: function _default(e) {
        return "The " + e + " value is not valid";
      },
      after: function after(e, n) {
        var t = n[0];
        return "The " + e + " must be after " + (n[1] ? "or equal to " : "") + t;
      },
      alpha: function alpha(e) {
        return "The " + e + " field may only contain alphabetic characters";
      },
      alpha_dash: function alpha_dash(e) {
        return "The " + e + " field may contain alpha-numeric characters as well as dashes and underscores";
      },
      alpha_num: function alpha_num(e) {
        return "The " + e + " field may only contain alpha-numeric characters";
      },
      alpha_spaces: function alpha_spaces(e) {
        return "The " + e + " field may only contain alphabetic characters as well as spaces";
      },
      before: function before(e, n) {
        var t = n[0];
        return "The " + e + " must be before " + (n[1] ? "or equal to " : "") + t;
      },
      between: function between(e, n) {
        return "The " + e + " field must be between " + n[0] + " and " + n[1];
      },
      confirmed: function confirmed(e) {
        return "The " + e + " confirmation does not match";
      },
      credit_card: function credit_card(e) {
        return "The " + e + " field is invalid";
      },
      date_between: function date_between(e, n) {
        return "The " + e + " must be between " + n[0] + " and " + n[1];
      },
      date_format: function date_format(e, n) {
        return "The " + e + " must be in the format " + n[0];
      },
      decimal: function decimal(e, n) {
        void 0 === n && (n = []);
        var t = n[0];
        return void 0 === t && (t = "*"), "The " + e + " field must be numeric and may contain" + (t && "*" !== t ? " " + t : "") + " decimal points";
      },
      digits: function digits(e, n) {
        return "The " + e + " field must be numeric and contains exactly " + n[0] + " digits";
      },
      dimensions: function dimensions(e, n) {
        return "The " + e + " field must be " + n[0] + " pixels by " + n[1] + " pixels";
      },
      email: function email(e) {
        return "The " + e + " field must be a valid email";
      },
      excluded: function excluded(e) {
        return "The " + e + " field must be a valid value";
      },
      ext: function ext(e) {
        return "The " + e + " field must be a valid file";
      },
      image: function image(e) {
        return "The " + e + " field must be an image";
      },
      included: function included(e) {
        return "The " + e + " field must be a valid value";
      },
      integer: function integer(e) {
        return "The " + e + " field must be an integer";
      },
      ip: function ip(e) {
        return "The " + e + " field must be a valid ip address";
      },
      ip_or_fqdn: function ip_or_fqdn(e) {
        return "The " + e + " field must be a valid ip address or FQDN";
      },
      length: function length(e, n) {
        var t = n[0],
            i = n[1];
        return i ? "The " + e + " length must be between " + t + " and " + i : "The " + e + " length must be " + t;
      },
      max: function max(e, n) {
        return "The " + e + " field may not be greater than " + n[0] + " characters";
      },
      max_value: function max_value(e, n) {
        return "The " + e + " field must be " + n[0] + " or less";
      },
      mimes: function mimes(e) {
        return "The " + e + " field must have a valid file type";
      },
      min: function min(e, n) {
        return "The " + e + " field must be at least " + n[0] + " characters";
      },
      min_value: function min_value(e, n) {
        return "The " + e + " field must be " + n[0] + " or more";
      },
      numeric: function numeric(e) {
        return "The " + e + " field may only contain numeric characters";
      },
      regex: function regex(e) {
        return "The " + e + " field format is invalid";
      },
      required: function required(e) {
        return "The " + e + " field is required";
      },
      required_if: function required_if(e, n) {
        return "The " + e + " field is required when the " + n[0] + " field has this value";
      },
      size: function size(e, n) {
        return "The " + e + " size must be less than " + function (e) {
          var n = 1024,
              t = 0 === (e = Number(e) * n) ? 0 : Math.floor(Math.log(e) / Math.log(n));
          return 1 * (e / Math.pow(n, t)).toFixed(2) + " " + ["Byte", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][t];
        }(n[0]);
      },
      url: function url(e) {
        return "The " + e + " field is not a valid URL";
      }
    },
    attributes: {}
  };
  return "undefined" != typeof VeeValidate && VeeValidate.Validator.localize(((e = {})[n.name] = n, e)), n;
});